import { useMemo } from "react";
import { EvaluationsQuery } from "../graphql/generated/graphql";

export function useAverageEvaluations(
  evaluationsData: EvaluationsQuery | undefined
) {
  return useMemo(() => {
    if (!evaluationsData?.evaluations?.nodes) return {};

    const scores: Record<string, number[]> = {};

    evaluationsData.evaluations.nodes.forEach(({ candidate, point }) => {
      if (candidate?.nodeId && point !== null) {
        scores[candidate.nodeId] = scores[candidate.nodeId] || [];
        scores[candidate.nodeId].push(point);
      }
    });

    const averages: Record<string, number> = {};
    for (const [nodeId, points] of Object.entries(scores)) {
      averages[nodeId] =
        points.reduce((acc, cur) => acc + cur, 0) / points.length;
    }

    return averages;
  }, [evaluationsData?.evaluations?.nodes]);
}
